import { render, staticRenderFns } from "./PresencasPage.vue?vue&type=template&id=2cbd92f2"
import script from "./PresencasPage.vue?vue&type=script&lang=js"
export * from "./PresencasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports